import axios from 'axios';

export const GET_NEW_INVOICE_ORDERS_COUNT = '/invoiceOrders/getNewInvoiceOrdersCount';

export function getNewInvoiceOrdersCount() {
  return axios.get(GET_NEW_INVOICE_ORDERS_COUNT, {});
}
